const ITEMS = [
  "Everybody is different",
  "Your healing should be too",
  "Ancient wisdom, gently renewed",
  "Healing precisely matched to you",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-border/50 py-10 lg:py-14">
    <div className="marquee-track flex w-max items-center">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
          {ITEMS.map((item) => (
            <span key={`${dup}-${item}`} className="flex items-center">
              <span className="whitespace-nowrap px-8 font-serif text-3xl font-light italic text-foreground/70 sm:text-5xl lg:px-12 lg:text-6xl">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rounded-full bg-accent" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
